<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <NotificationFilters></NotificationFilters>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Kolejka powiadomień
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="add"
              >
                Nowe powiadomienie
              </v-btn>
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
              <v-btn
                  v-if="selected.length"
                  class="mx-2"
                  @click="cancelSelected"
              >
                Anuluj wybrane
              </v-btn>
            </div>
            <data-table
                v-model="selected"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                show-select
                class="row-pointer"
                @click:row="onRowClicked"
            >
              <template v-slot:item.delayInMinutes="{ item }">
                {{ formatMinutes(item.delayInMinutes) }}
              </template>
              <template v-slot:item.hourStart="{ item }">
                {{ item.hourStart }}:00 - {{ item.hourStop }}:00
              </template>
              <template v-slot:item.targetUser="{ item }">
                <router-link
                    v-if="item.targetUser"
                    :to="{name: 'user-details', params: {id: item.targetUser}}"
                >
                  #{{ item.targetUser }}
                </router-link>
              </template>
              <template v-slot:item.creator="{ item }">
                <router-link
                    v-if="item.creator"
                    :to="{name: 'user-details', params: {id: item.creator}}"
                >
                  #{{ item.creator }}
                </router-link>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt) }}
              </template>
              <template v-slot:item.cancelledAt="{ item }">
                {{ localDateTime(item.cancelledAt) }}
                <div v-if="item.cancelledAt.timestamp">
                  Przez:
                  <router-link
                      v-if="item.cancelledBy"
                      :to="{name: 'user-details', params: { id: item.cancelledBy }}"
                  >
                    #{{ item.cancelledBy }}
                  </router-link>
                  <em v-if="item.cancelledAt.timestamp && !item.cancelledBy">
                    System
                  </em>
                </div>
              </template>
              <template v-slot:item.delegatedForAndroidAt="{ item }">
                <span v-html="formatDelegatedAt(item)"/>
              </template>
              <template v-slot:item.batchId="{ item }">
                <v-tooltip
                    :disabled="!item.batchCancelledAt || !item.batchCancelledAt.timestamp"
                    top
                >
                  <template v-slot:activator="{ on }">
                    <div v-if="item.batchId"
                          style="width:118px"
                          v-bind:class="[
                            {
                              'red--text': item.batchCancelledAt && item.batchCancelledAt.timestamp,
                            }
                          ]"
                          v-on="on"
                    >
                      {{ item.batchId }}
                    </div>
                  </template>
                  Ta paczka powiadomień została anulowana. Wkrótce powiadomienia wchodzące w jej skład
                  również zostaną oznaczone jako anulowane. Stanie się to przed pierwszą próbą ich wysłania.
                </v-tooltip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                    v-if="canBeCancelled(item)"
                    small
                    :disabled="!!item.processed"
                    @click="cancelJob(item, $event)"
                    title="Anuluj wysyłkę."
                >
                  mdi-delete
                </v-icon>
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '../services/api';
import formatters from '@/mixins/formatters';
import DataTable from '@/components/data-table/DataTable';
import NotificationFilters from '@/components/notifications/NotificationFilters';
import filters from '@/mixins/filters';
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    DataTable,
    NotificationFilters,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      options: {},
      headers: [
        {text: 'Tytuł', value: 'title', sortable: false},
        {text: 'Opóźnienie', value: 'delayInMinutes', sortable: false},
        {text: 'Przedział godzinowy', value: 'hourStart', sortable: false},
        {text: 'URL', value: 'targetUrl', sortable: false},
        {text: 'Odbiorca', value: 'targetUser', sortable: false},
        {text: 'Zakolejkował', value: 'creator', sortable: false},
        {text: 'Zakolejkowano', value: 'createdAt', sortable: false},
        {text: 'Anulowano', value: 'cancelledAt', sortable: false},
        {text: 'Wysłano', value: 'delegatedForAndroidAt', sortable: false},
        {text: 'Paczka', value: 'batchId', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      selected: [],
      filters: {},
    }
  },
  created() {
    getDatatableParams.call(this);
    this.load();
  },
  mounted() {
    const self = this;

    this.$root.$on('loadNotifications', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'title', filters.title, 2);
      this.appendStringFilterIfNonEmpty(params, 'body', filters.body, 2);
      this.appendStringFilterIfNonEmpty(params, 'targetUrl', filters.targetUrl, 2);
      this.appendRangeFilterIfNonEmpty(params, 'delayInMinutes', filters.delayInMinutes, 0, 2880);
      this.appendRangeFilterIfNonEmpty(params, 'hours', filters.hours, 0, 23);
      this.appendStringFilterIfNonEmpty(params, 'createdAtFrom', filters.createdAtFrom, 10);
      this.appendStringFilterIfNonEmpty(params, 'createdAtTo', filters.createdAtTo, 10);
      this.appendBoolFilterIfNonEmpty(params, 'forMobile', filters.forMobile, true);
      this.appendBoolFilterIfNonEmpty(params, 'forWeb', filters.forWeb, true);
      this.appendBoolFilterIfNonEmpty(params, 'sent', filters.sent, true);
      this.appendBoolFilterIfNonEmpty(params, 'notSent', filters.notSent, true);
      this.appendBoolFilterIfNonEmpty(params, 'cancelled', filters.cancelled, true);
      this.appendBoolFilterIfNonEmpty(params, 'notCancelled', filters.notCancelled, true);
      this.appendBoolFilterIfNonEmpty(params, 'withoutBatch', filters.withoutBatch, true);
      this.appendIntFilterIfNonEmpty(params, 'targetUser', filters.targetUser);
      this.appendIntFilterIfNonEmpty(params, 'creator', filters.creator);
      this.appendStringFilterIfNonEmpty(params, 'batchId', filters.batchId, 2);
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;

      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/notifications', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy powiadomień.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onRowClicked(item) {
      this.$router
          .push({
            name: 'notifications-details', params: {
              id: item.id,
            }
          })
          .catch(() => {
          });
    },
    add() {
      this.$router
          .push({name: 'notifications-add'})
          .catch(() => {
          });
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadNotifications', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista została odświeżona.',
          });
        }
      });
    },
    cancelSelected() {
      if (!this.selected.length) {
        return;
      }

      this.cancelJobs(this.selected);
    },
    cancelJobs(items) {
      if (this.loading) {
        return;
      }

      const map = items.reduce((result, item) => {
        result[item.id] = item;

        return result;
      }, {});
      const ids = items.map(item => item.id);

      Object.keys(map).forEach((key) => {
        map[key].processed = true;
      });

      api.delete('/api/notifications', {data: {ids: ids}})
          .then((response) => {
            const results = response.data.items;

            results.forEach((data) => {
              if (map[data.id]) {
                map[data.id].cancelledAt = data.cancelledAt;
              }
            });

            this.$root.$emit('notifySuccess', {
              html: `Wysyłka wybranych powiadomień została anulowana.`,
            });
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się anulować wysyłki wybranych powiadomień.',
              error,
            });
          })
          .finally(() => {
            Object.keys(map).forEach((key) => {
              delete map[key].processed;
            });
          });
    },
    cancelJob(item, event) {
      if (this.loading) {
        return;
      }

      let $icon = null;

      if (event) {
        $icon = event.target;

        // The following line is required to avoid triggering onRowClicked() method.
        event.cancelBubble = true;
      }

      if (item.processed) {
        return;
      }

      const id = item.id;
      item.processed = true;

      if ($icon) {
        $icon.disabled = true;
        $icon.classList.add('v-icon--disabled');
      }

      api.delete(`/api/notifications/${id}`)
          .then((response) => {
            item.cancelledAt = response.data.cancelledAt;
            this.$root.$emit('notifySuccess', {
              html: `Wysyłka powiadomienia została anulowana.`,
            });
          })
          .catch((error) => {
            if ($icon) {
              $icon.disabled = false;
              $icon.classList.remove('v-icon--disabled');
            }

            this.$root.$emit('notifyError', {
              html: 'Nie udało się anulować wysyłki powiadomień.',
              error,
            });
          })
          .finally(() => {
            delete item.processed;
          });
    },
    formatDelegatedAt(item) {
      let mobile = this.localDateTime(item.delegatedForAndroidAt);
      let web = this.localDateTime(item.delegatedForWebAt);

      if (!mobile) {
        if (item.cancelledAt && item.cancelledAt.timestamp) {
          mobile = '<em class="red--text">wysyłka anulowana</em>';
        } else {
          if (item.forAndroid || item.for_iOs) {
            mobile = '<em class="warning--text">jeszcze nie wysłano</em>';
          } else {
            mobile = '<em>nie dotyczy</em>';
          }
        }
      }

      if (!web) {
        if (item.cancelledAt && item.cancelledAt.timestamp) {
          web = '<em class="red--text">wysyłka anulowana</em>';
        } else {
          if (item.forWeb) {
            web = '<em class="warning--text">jeszcze nie wysłano</em>';
          } else {
            web = '<em>nie dotyczy</em>';
          }
        }
      }

      return `Mobilne: ${mobile}<br>Przeglądarka: ${web}`;
    },
    canBeCancelled(item) {
      if (item.cancelledAt && item.cancelledAt.timestamp) {
        return false; // Already cancelled.
      }

      return true;
    },
  },
}
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>